import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a Junior Software Engineer who loves transforming ideas into
              reliable, scalable products. Over time, I’ve explored several
              technologies and found my passion in building high-performance
              systems and intuitive user experiences.
              <br />
              <br />
              I’m specializing in
              <i>
                <b className="purple">
                  {" "}
                  JavaScript, Java, and C#{" "}
                </b>
              </i>
              — and I enjoy working across both backend and frontend stacks.
              <br />
              <br />
              My key areas of interest include developing
              <i>
                <b className="purple">
                  {" "}
                  MERN stack Web Applications,{" "}
                </b>
              </i>
              with good looking frontend and scalable backend.
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> Node.js </b> and modern frameworks like{" "}
              <i>
                <b className="purple">React.js</b>.
              </i>
              &nbsp;Contributed to manufacturing software solutions for <b className="purple">Lear Corporation</b> and built AI-driven interactive web applications.
              Strong foundation in REST APIs, system architecture, and code refactoring, with working experience in Java for enterprise environments.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img  style={{ maxHeight: "350px" }} src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
